import {Component, ViewEncapsulation, OnInit, Input, OnDestroy} from '@angular/core';
import {Observable} from 'rxjs';
import {tap} from 'rxjs/operators';
import {TableauService} from '@cupoui/core/services/tableau.service';
import {Error} from '../error-message/error-message.component';
import {TranslateService} from '@ngx-translate/core';
import {NGXLogger} from 'ngx-logger';
import {UntilDestroy} from '@ngneat/until-destroy';
import {CookieService} from "ngx-cookie-service";
import {TableauViz} from "../../../../content/js/tableau.embedding.3.latest.min"
import Keycloak from "keycloak-js";

declare var tableau: any;

@Component({
    selector: 'app-tableau',
    templateUrl: './tableau.component.html',
    styleUrls: ['./tableau.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
@UntilDestroy({ checkProperties: true })
export class TableauComponent implements OnInit, OnDestroy {
  @Input() target: string;
  @Input() view: string;
  @Input() profile: string;
  @Input() width: string;
  @Input() height: string;

  ticket: string;
  error: any;
  defaultSize = { width: '800', height: '600' };
  loaded = false;
  errorDetailsVisible = false;

  constructor(
    private readonly tableauService: TableauService,
    private readonly keycloak: Keycloak,
    private readonly  cookieService: CookieService,
    private readonly translateService: TranslateService,
    private readonly logger: NGXLogger) {}

  ngOnInit(): void {
    this.fetchTicket()
      .subscribe(
        {
          next: () => {
            this.cookieService.set('access_token', this.keycloak.token)
            this.initViz(this.target, this.view, this.ticket)
          },
          error: (err: string) => {
            this.logger.debug('Error fetching ticket!', err);
            this.error = err;
          }
        }
      );
  }

  ngOnDestroy() {
    this.cookieService.delete("access_token")
  }

  toggleErrorDetails(): void {
    this.errorDetailsVisible = !this.errorDetailsVisible;
  }

  private fetchTicket(): Observable<string> {
    return this.tableauService.getTicket(this.profile).pipe(
      tap(response => {
        this.ticket = response;
        if (this.ticket === '-1') {
          throw new Error(this.translateService.instant('Error fetching ticket!'));
        }
      })
    );
  }

  private initViz(target: string, view: string, ticket: string): void {
    this.loaded = true;
    const tableauDiv = document.getElementById('tableauViz');
    const viz = new TableauViz();
    viz.src = `${this.getHost()}/services/api/tableau/trusted/${ticket}/t/${target}/views/${view}`;
    //viz.src = `https://euitabe02.sos.eu/trusted/${ticket}/t/CustomerPortal/views/Insights/Cases`;
    viz.toolbar = 'hidden';
    // viz.width = this.width ? this.width : tableauDiv?.offsetWidth ? tableauDiv.offsetWidth.toString() : this.defaultSize.width;
    // viz.height = this.height ? this.height : tableauDiv?.offsetHeight ? tableauDiv.offsetHeight.toString() : this.defaultSize.height;
    tableauDiv.appendChild(viz);
  }

  private getHost(): string {
    return window.location.port ? `http://${window.location.hostname}:${window.location.port}` : `https://${window.location.hostname}`;
  }
}
